import { render, staticRenderFns } from "./ZdmReportsTab.vue?vue&type=template&id=3f62773c&scoped=true&"
import script from "./ZdmReportsTab.vue?vue&type=script&lang=js&"
export * from "./ZdmReportsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f62773c",
  null
  
)

export default component.exports